module.exports = __webpack_public_path__ + "static/media/alison-brie.f95c3888.jpg";